import { ColorBadge } from './Badges/ColorBadge';
import { TextBadge } from './Badges/TextBadge';
import { MapToBadgeFunction } from './model';

export const mapToBadge: MapToBadgeFunction = (node, commonProps) => {
    switch (node.alias) {
        case 'COLOR':
            return <ColorBadge key={node.key} {...commonProps} color={node.data.color} colorName={node.data.name} />;
        case 'SIZE':
        case 'RAM_CAPACITY':
            return (
                <TextBadge key={node.key} {...commonProps} name={`${node.alias}-selection`}>
                    {`${node.data.name} GB`}
                </TextBadge>
            );
        case 'DIAGONAL':
        case 'BAND_SIZE':
        case 'SCREEN_SIZE':
        case 'SCREEN_SIZE_IN':
        case 'SCREEN_SIZE_MM':
        case 'RING_SIZE':
        case 'INTERNET_CONNECTION':
            return (
                <TextBadge key={node.key} {...commonProps} name={`${node.alias}-selection`}>
                    {node.data.name}
                </TextBadge>
            );
        default:
            return null;
    }
};
